import { render } from "./geneticAdmin.vue?vue&type=template&id=12ec2a6e&scoped=true"
import script from "./geneticAdmin.vue?vue&type=script&lang=js"
export * from "./geneticAdmin.vue?vue&type=script&lang=js"

import "./geneticAdmin.vue?vue&type=style&index=0&id=12ec2a6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ec2a6e"]])

export default __exports__